/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { EntWebsiteContext } from 'bundles/ent-website/components/EntWebsiteContext';

type Props = {
  msg: string;
};

/**
 * Note: This component is used for content author only and is only rendered in preview mode.
 * So it intentionally does not use CDS to make it ugly and stand out.
 */
function NativeError({ msg }: Props) {
  const styles = css`
    color: #fff;
    background-color: #f00;
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
  `;

  const { isPreview } = React.useContext(EntWebsiteContext);

  // only render in preview mode
  if (!isPreview) {
    return null;
  }

  return (
    <div css={styles}>
      <h2>EntWebsite - Native</h2>
      <p>{msg}</p>
    </div>
  );
}

export default NativeError;
